import { currentUser } from '../../api';
import { fetchCurrentUserFailure, fetchCurrentUserStart } from './index';
import { TDispatch, TGetState } from 'state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { getNetwork } from 'app/scripts/services/app-state';
import { fetchCurrentUserSuccess } from '../../../../../current-user/currentUserSlice';
import { parseCurrentUser } from '../../../../../current-user/currentUserUtils';
import { CurrentUserResponse } from '../../../../../current-user/currentUserTypes';
import { AnalyticsProvider } from '../../../../services/analytics-provider';

interface Payload {
  // By providing these you can select the next spot to be authenticated to
  // overriding the current state spot and network;

  spotId?: string;
  networkId?: string;
  originalNetworkId?: string;
}

const fetchCurrentUser = (payload: Payload = {}) => {
  return async (dispatch: TDispatch, getState: TGetState): Promise<CurrentUserResponse> => {
    const { spotId: currentSpotId, network } = getState().application;

    // We can override spotId and networkId by providing them on the action payload.
    const spotId = payload?.spotId ?? currentSpotId;
    const networkId = payload?.networkId ?? network.networkId;
    const originalNetworkId = payload?.originalNetworkId;

    dispatch(fetchCurrentUserStart({ spotId, networkId }));

    if (!spotId || !network.networkId) {
      throw new Error(
        `Can't request currentUser data without spotId and networkId, got: ${spotId}, ${network.networkId} `
      );
    }

    try {
      const response = await currentUser(spotId, networkId, originalNetworkId || getNetwork().id);
      const currentUserData = parseCurrentUser(response);
      dispatch(fetchCurrentUserSuccess(currentUserData));

      // TODO: This is mandatory for letting all internal state reducers to know
      // when the spotId has changed so we can reset state to all of them.
      dispatch({ type: 'SPOTS/CHANGE_SPOT' });

      AnalyticsProvider.initializePeople(currentUserData);

      return response;
    } catch (error) {
      console.error(error);
      dispatch(fetchCurrentUserFailure());
      ErrorNotifier.notifyError(new Error(`Failed to fetch current user for ${spotId}`));
    }
  };
};

export default fetchCurrentUser;
